import QuickActions from '../../containers/LoggedOut/QuickActions/QuickActions';

export const QuickActionsRoutes = [
	{
		...QuickActions,
		path: '/quick-actions',
		pathRegex: '/quick-actions/',
		titleId: 'app.document.title.quickaction',
	},
];
